import { FormBuilder, Validators } from '@angular/forms';
var MemberFormComponent = /** @class */ (function () {
    function MemberFormComponent(formBuilder) {
        this.formBuilder = formBuilder;
        /**
         * Informs if loading is active or not
         */
        this.isLoading = false;
        this.createForm();
    }
    /**
     * Data selection action by clicking the form submit button
     */
    MemberFormComponent.prototype.doSubmit = function () {
        this.modal.close({
            action: 'save',
            form: 'member',
            formData: this.memberForm.value
        });
    };
    Object.defineProperty(MemberFormComponent.prototype, "f", {
        /**
         *  Getter to access the form fields
         *
         *  @return AbstractControl
         */
        get: function () {
            return this.memberForm.controls;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Form creation and validation configuration
     */
    MemberFormComponent.prototype.createForm = function () {
        this.memberForm = this.formBuilder.group({
            member: ['', Validators.required]
        });
    };
    return MemberFormComponent;
}());
export { MemberFormComponent };
